/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { createTheme } from "@mui/material";

export const themeOptions = createTheme({
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
  },
});
